import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export type TerminationErrorCode = 'TOKEN_NOT_FOUND' | 'ALREADY_SIGNED' | 'LINK_EXPIRED' | 'INTERNAL_ERROR';

export interface ValidateTerminationTokenResponse {
  success: boolean;
  data?: {
    id: string;
    address: string;
    apartmentNumber: string;
    city: string;
    tenantFirstName: string;
    tenantLastName: string;
    moveOutDate: string;
    reason?: string;
    initiatedDate: string;
  };
  error?: string;
  errorCode?: TerminationErrorCode;
}

export interface SignTerminationResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export async function validateTerminationToken(token: string): Promise<ValidateTerminationTokenResponse> {
  try {
    const validate = httpsCallable<{ token: string }, ValidateTerminationTokenResponse>(
      functions,
      'validateTerminationToken'
    );
    const result = await validate({ token });
    return result.data;
  } catch (error: any) {
    console.error('Error validating termination token:', error);
    return {
      success: false,
      error: error.message || 'Ett fel uppstod vid validering av token'
    };
  }
}

export async function signTermination(token: string): Promise<SignTerminationResponse> {
  try {
    const sign = httpsCallable<{ token: string }, SignTerminationResponse>(
      functions,
      'signTermination'
    );
    const result = await sign({ token });
    return result.data;
  } catch (error: any) {
    console.error('Error signing termination:', error);
    return {
      success: false,
      error: error.message || 'Ett fel uppstod vid signering'
    };
  }
}
